<template>
  <div
    style="
      width: 400px;
      height: 360x;
      padding: 10px;
      border-radius: 10px;
      box-shadow: 0px 0px 5px 0px #d6d3d3;
    "
  >
    <el-alert
      center
      class="info-title"
      title="更改密码"
      type="info"
      style="margin-bottom: 30px"
      :closable="false"
    >
    </el-alert>
    <el-form :model="form" ref="form" label-width="100px" :rules="formValidate">
      <!--      <el-form-item label="原密码:" prop="oldPassword">-->
      <!--        <el-input v-model="form.oldPassword" type="password"></el-input>-->
      <!--      </el-form-item>-->
      <el-form-item label="新密码:" prop="newPassword">
        <el-input v-model="form.newPassword" type="password"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="passwordConfirm">
        <el-input v-model="form.passwordConfirm" type="password"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" style="text-align: center" class="dialog-footer">
      <!--      <el-button @click="handleCancel">取 消</el-button>-->
      <el-button type="primary" @click="handleSumbit">确 定</el-button>
    </div>
  </div>
</template>

<script>
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import { CONST_VD_IMGPREFIX } from "@/config/constant";

export default {
  props: {
    show: Boolean,
  },
  data() {
    const validateNewPass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else if (value == this.form.oldPassword) {
        callback(new Error("原始密码与新密码一致"));
      } else {
        callback();
      }
    };
    const validatePassCheck = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入确认密码"));
      } else if (value != this.form.newPassword) {
        callback(new Error("两次输入的密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      brandId: 0,
      form: {
        oldPassword: "",
        newPassword: "",
        passwordConfirm: "",
      },
      formValidate: {
        newPassword: [
          { required: true, validator: validateNewPass, trigger: "blur" },
        ],
        passwordConfirm: [
          { required: true, validator: validatePassCheck, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    handleCancel() {
      this.$emit("update:show", false);
    },
    handleSumbit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("on-submit", this.form.newPassword);
        } else {
          this.$message.error("请填写内容");
        }
      });
    },
  },
  watch: {
    show(val) {},
  },
};
</script>

<style></style>
